(function () {
  document.querySelectorAll('.product__media-list .product__media-item').forEach((mediaItem) => {
    const hasAigenImage = Array.from(mediaItem.querySelectorAll('img')).some((img) =>
      img.src.includes('_aigen_')
    );

    if (hasAigenImage) {
      mediaItem.classList.add('aigen-img');

      if (!mediaItem.querySelector('.aigen-badge')) {
        const badge = document.createElement('div');
        badge.className = 'aigen-badge';
        badge.textContent = 'Edited by AI';

        const mediaWrapper = mediaItem.querySelector('.product-media-container');
        if (mediaWrapper) {
          mediaWrapper.appendChild(badge);
        } else {
          mediaItem.appendChild(badge);
        }
      }
    }
  });
})();
